
import { contextFactory } from '@/src/helpers';
import { FC, useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { useXRPL } from '../hooks';

const [XPRLContext, useXRPLContext] = contextFactory<ReturnType<typeof useXRPL>>({
  hook: 'useXRPLContext',
  provider: 'XRPLProvider',
});

export const XRPLProvider: FC<{ children: React.ReactNode }> = ({ children }) => {
  const xrpl = useXRPL();
  const queryClient = useQueryClient();

  // Clear React Query cache when client changes (network switch)
  useEffect(() => {
    // Clear all XRPL-related queries when network switches
    queryClient.removeQueries({
      predicate: (query) => {
        const key = query.queryKey[0];
        // Remove queries for XRPL data that start with known query keys
        return (
          typeof key === 'string' &&
          (key.includes('AccountInfo') ||
            key.includes('AccountLines') ||
            key.includes('AccountOffers') ||
            key.includes('AccountTx') ||
            key.includes('BookOffers') ||
            key.includes('GetAggregatePrice'))
        );
      },
    });

    console.debug('[xrpl-provider] Cleared React Query cache for network switch');
  }, [xrpl.client, queryClient]);

  return <XPRLContext.Provider value={xrpl}>{children}</XPRLContext.Provider>;
};

export { useXRPLContext, XPRLContext };
